// Libs
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import CourseService from 'services/CourseService';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class EnablementComparePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        GlobalStateService.setValues({ area: 'enablement-compare' });
    }

    async upload(field) {
        if (field.files.length > 0) {
            const file = field.files[0];
            this.setState({
                isUploading: true,
                isCompleted: false
            });
            const results = await CourseService.runEnablementCompare(file);
            field.value = '';
            this.setState({
                fileName: file.name,
                isUploading: false,
                results
            });
        }
    }

    async exportToExcel() {
        await CourseService.runEnablementCompareExcel(this.state.results);
    }

    //-------------------------------------------------------------------------------------------------------

    render() {
        const {
            results
        } = this.state;

        return (
            <div className="page enablement-compare-page">

                <PageHeader>
                    <h1>Enablement Compare</h1>

                    <div className="buttons">

                        {results &&
                            <button className="btn btn-primary btn-block" onClick={() => window.location.reload()}>
                                Start again
                            </button>
                        }

                        {results &&
                            <button className="btn btn-primary" onClick={e => this.exportToExcel()}>
                                Export to Excel
                            </button>
                        }

                    </div>
                </PageHeader>

                <main>

                    <Container>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderInner() {
        const {
            isUploading,
            fileName,
            results
        } = this.state;

        if (isUploading) {
            return (<Loader />);
        }

        if (!results) {
            return (<>
                <h2>Please upload an .XLS/.XLSX file</h2>

                <label className="btn btn-secondary btn-block upload-button">
                    {isUploading ? <>
                        <Loader isInline />{' '}Uploading...
                    </> : <>
                        {fileName ? <>
                            <span className="fa-solid fa-check"></span>{' '}{fileName}
                        </> : <>
                            <span className="fa-solid fa-upload"></span>{' '}Upload
                        </>}
                        <input
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={e => this.upload(e.target)}
                        />
                    </>}
                </label>
            </>);
        }

        if (results.length == 0) {
            return (
                <div className="empty-text">
                    No items
                </div>
            );
        }

        return (
            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table enablement-compare-results-table">
                    <thead>
                        <tr>
                            <th className="instructor-col">Instructor</th>
                            <th className="active-status-col">Active Status</th>
                            <th className="course-col">Course</th>
                            <th className="go-courses-col">Go Courses</th>
                            <th className="vendor-col">Vendor</th>
                            <th className="error-col">Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map((result, index) =>
                            <tr key={index} className={`active-status-${(result.instructor.activeStatus || '').toLowerCase()}`}>
                                <td className="instructor-col">
                                    {TextHelpers.formatInstructorName(result.instructor)}

                                    {result.instructor.slug &&
                                        <Link to={`/instructor/${result.instructor.slug}`} className="ms-2 btn btn-default btn-sm" target="_blank">
                                            <span className="fa-solid fa-search" />
                                        </Link>
                                    }
                                </td>
                                <td className="active-status-col">
                                    {result.instructor.activeStatus}
                                </td>
                                <td className="course-col">
                                    {result.courseName}
                                </td>
                                <td className="go-courses-col">
                                    {result.isPresentGoCourses ?
                                        <span className="fa-solid fa-check text-good" /> :
                                        <span className="fa-solid fa-times text-bad" />
                                    }
                                </td>
                                <td className="vendor-col">
                                    {result.isPresentVendor ?
                                        <span className="fa-solid fa-check text-good" /> :
                                        <span className="fa-solid fa-times text-bad" />
                                    }
                                </td>
                                <td className="error-col">
                                    {result.error || result.warning}
                                </td>
                            </tr>
                        )}
                        {results.length == 0 &&
                            <tr>
                                <td colSpan={5} className="empty-text">
                                    There are no differences
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(EnablementComparePage);